<div class="mx-auto max-w-7xl px-4 py-7 sm:px-6 lg:px-8">
  <div class="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-12">
    <div class="lg:col-span-5 h-full">
      <div class="card bg-base-100 dark:bg-black dark:border-1 dark:border-base-100 shadow-sm h-full">
        <div class="card-body">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Your Multinode is on its way!</h2>
          </div>
          <div class="whitespace-pre-wrap">
            {{profile?.invite_message}}
          </div>
        </div>
      </div>
    </div>
    <div class="sm:mx-0 sm:rounded-lg lg:col-span-7 h-full">
      <div class="card h-full bg-primary shadow-sm bg-[url(/assets/setup_device.png)] min-h-[400px] bg-no-repeat  bg-contain sm:bg-size-[420px_auto] sm:bg-right bg-bottom">
        <div class="card-body">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold text-white">How to set up your multinode</h2>
          </div>
          <p class="text-white">Read the quick start guide.</p>
        </div>
        <div class="card-actions p-6">
          <a class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 hover:text-primary dark:text-white" href="/docs/multinode/quickstart">
            <span>Open Quick Start Guide</span>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
              <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-12 mt-8">
    <div class="lg:col-span-4 h-full">
      <div class="card bg-base-100 shadow-sm h-full dark:bg-black dark:border-1 dark:border-base-100">
        <div class="card-body flex">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Nodes</h2>
          </div>
          <div class="grow">
            <p>Your nodes</p>
            <ul class="list bg-base-100 dark:bg-black mt-4">
              @for (node of nodes; track node) {
                <li class="bg-[#EEFADF] dark:bg-[#1c2d07]  mt-2 first:mt-0">
                  <a class="flex p-1 items-center" routerLink="/devices">
                    <img src="assets/multinode_icon.png" class="w-10"/>
                    <div class="ml-2 break-all dark:text-white">{{ node.description || node.devaddr }}</div>
                  </a>
                </li>
              } @empty {
                <li class="text-sm text-gray-500 dark:text-gray-400 mt-2">
                  {{ loadingNodes ? 'Loading nodes…' : 'No nodes yet' }}
                </li>
              }
            </ul>
          </div>
          <div class="card-actions mt-4">
            <a routerLink="/devices" class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 hover:text-primary dark:bg-black dark:text-white">
              <span>All Nodes</span>
              <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:col-span-4 h-full">
      <div class="card bg-base-100 shadow-sm h-full dark:bg-black dark:border-1 dark:border-base-100">
        <div class="card-body flex">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Documentation</h2>
          </div>
          <div class="grow">
            <p>Resources and guides</p>
            <ul class="list bg-base-100 dark:bg-black mt-4">
              <li class="border border-[#E6DBF9] dark:border-base-100 rounded-sm">
                <a class="flex p-3 items-center" href="/docs/system-overview">
                  <div class="text-primary break-all dark:text-white">Overview</div>
                </a>
              </li>
              <li class="border border-[#E6DBF9] dark:border-base-100 rounded-sm mt-2">
                <a class="flex p-3 items-center" href="/docs/api">
                  <div class="text-primary break-all dark:text-white">API docs</div>
                </a>
              </li>
            </ul>
          </div>
          <div class="card-actions mt-4">
            <a routerLink="/docs" class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 hover:text-primary dark:bg-black dark:text-white">
              <span>All Documentation</span>
              <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="sm:mx-0 sm:rounded-lg lg:col-span-4">
      <div class="card bg-[#eefadf] shadow-sm bg-[url(/assets/satellite_bg.png)] sm:min-h-[400px] bg-no-repeat bg-contain bg-bottom-right">
        <div class="card-body">
          <div class="flex justify-between">
            <h2 class="text-2xl font-bold text-primary">Satellite Pass Prediction</h2>
          </div>
          <p>Find out when the next satellite passes overhead.</p>
        </div>
        <div class="card-actions p-6">
          <a routerLink="/pass_prediction" class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 hover:text-primary dark:bg-black dark:text-white">
            <span>Calculate Satellite Pass</span>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
              <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
